import * as React from "react";
import PropTypes from 'prop-types';

const SvgPlus = props => {
  if (props.id !== "_svgplus") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M20 5c.64 0 1.15.75 1.15 1.67v12.18h12.18c.92 0 1.67.51 1.67 1.15 0 .64-.75 1.15-1.67 1.15H21.15v12.18c0 .92-.51 1.67-1.15 1.67-.64 0-1.15-.75-1.15-1.67V21.15H6.67C5.75 21.15 5 20.64 5 20c0-.64.75-1.15 1.67-1.15h12.18V6.67c0-.92.51-1.67 1.15-1.67" /></svg>;
};

SvgPlus.displayName = "_svgplus";
SvgPlus.propTypes = {
  id: PropTypes.string
};
SvgPlus.defaultProps = {
  id: ''
};
export default SvgPlus;